import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDemoLimitsData } from "./demoLimits.t";

export interface IDemoLimitsState {
    error: unknown,
    freeOrdersLeft: number | null;
    isLoading: boolean,
    ordersLimit: number | null;
}

const initialState: IDemoLimitsState = {
    error: null,
    freeOrdersLeft: null,
    isLoading: true,
    ordersLimit: null,
};

export const demoLimitsSlice = createSlice({
    name: 'demoLimits',
    initialState,
    reducers: {
        getFreeOrdersLeftAction() {
        },
        getFreeOrdersLeftSuccess(state, action: PayloadAction<IDemoLimitsData>) {
            const { freeOrdersLeft, ordersLimit } = action.payload;
            state.freeOrdersLeft = freeOrdersLeft;
            state.ordersLimit = ordersLimit;
            state.isLoading = false;
            state.error = null;
        },
        getFreeOrdersLeftFailure(state, action: PayloadAction<unknown>) {
            state.error = action.payload;
        },
        handleOrderCommittedAction(state, action: PayloadAction<{ accountCode: string }>) {},
    },
});

export default demoLimitsSlice.reducer;